var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.Constants.ServerUrl + '/service/devize/deviz_produse/' + _vm.IdDeviz,"width":"100%","height":_vm.parentHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }